import request from 'utils/request'
import api from 'common/api/departments'
import {stringify} from 'qs'

export async function currentTree() {
    return request(api.currentTree.url, null, {
        checkMetaCode: false,
    })
}

export async function departments(params) {
    return request(`${api.departments.url}?${stringify(params)}`)
}
